










import { Component, Vue, Prop } from 'vue-property-decorator';
import { ApprovalStatus } from '@/interfaces/server-data';

@Component({
  name: 'ApprovalStatusBadge'
})
export default class ApprovalStatusBadge extends Vue {
  @Prop({ type: String, required: false })
  status?: ApprovalStatus;

  get statusLabel(): string {
    if (!this.status) return '';
    
    switch (this.status) {
      case ApprovalStatus.APPROVED_AUTOMATICALLY:
        return this.$t('approvalStatus.auto') as string;
      case ApprovalStatus.APPROVED_MANUALLY:
        return this.$t('approvalStatus.manual') as string;
      case ApprovalStatus.NOT_APPROVED:
        return this.$t('approvalStatus.notApproved') as string;
      default:
        return this.status;
    }
  }

  get badgeClass(): string {
    if (!this.status) return '';
    
    switch (this.status) {
      case ApprovalStatus.APPROVED_AUTOMATICALLY:
        return 'approved-automatically';
      case ApprovalStatus.APPROVED_MANUALLY:
        return 'approved-manually';
      case ApprovalStatus.NOT_APPROVED:
        return 'not-approved';
      default:
        return '';
    }
  }

  get iconClass(): string {
    if (!this.status) return '';
    
    switch (this.status) {
      case ApprovalStatus.APPROVED_AUTOMATICALLY:
        return 'ant-icon anticon-check-circle';
      case ApprovalStatus.APPROVED_MANUALLY:
        return 'ant-icon anticon-user';
      case ApprovalStatus.NOT_APPROVED:
        return 'ant-icon anticon-minus-circle';
      default:
        return '';
    }
  }
}
